import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getAnalysisReportsRequest } from "../../requests/analysisReports";

// import getTrackInfo from "../../requests/trackInfo";
import { setTracks } from "../../store/actions/tracks";
import AnalysisForm from "../../components/Reports/AnalysisForm";
import Reports from "../../components/Reports";

const AnalysisReports = props => {
  const [reports, setReports] = useState();
  const [search, setSearch] = useState();
  const [options, setOptions] = useState({});
  const [searchType, setSearchType] = useState();
  useEffect(() => {
    setTimeout(() => {
      window.scroll(0, 0)
    }, 1000)
  }, [])
  return (
    <>
      <AnalysisForm
        onSubmit={options => {
          setOptions(options);
          return new Promise((resolve, reject) => {
            getAnalysisReportsRequest(options)
              .then(response => {
                let data = response.data.analysisData;
                let trackIds = [];
                Object.keys(data).forEach(key => {
                  if (key.indexOf("Track") > -1) {
                    data[key].forEach(track => {
                      if (
                        !props.tracks[track.key] &&
                        !trackIds.includes(track.key)
                      ) {
                        trackIds = [...trackIds, track.key];
                      }
                    });
                  }
                });
                // if (trackIds.length) {
                //   getTrackInfo(trackIds.join(","))
                //     .then(({ data }) => {
                //       props.setTracks(data.tracks);
                //       setReports(response.data.analysisData);
                //       resolve();
                //     })
                //     .catch(error => reject(error));
                // } else {
                // }
                setReports(response.data.analysisData);
                resolve();
                setSearch(options.search);
                setSearchType(options.type);
              })
              .catch(error => reject(error));
          });
        }}
        options={{
          ...options,
          search: search,
          type: searchType
        }}
      />
      <Reports
        data={reports}
        tables
        charts
        showDetailsButton
        showNav
        onTableRowDetails={props => {
          const { type, ...rest } = props;
          setSearch([{ ...rest }]);
          setSearchType(type);
          window.scroll(0, 0);
          setTimeout(() => {
            document
              .getElementById("analysis-form")
              .dispatchEvent(new Event("submit", { cancelable: true }));
          }, 200);
        }}
        location={props.location}
      />
    </>
  );
};

export default connect(
  state => ({
    tracks: state.tracks
  }),
  dispatch =>
    bindActionCreators(
      {
        setTracks
      },
      dispatch
    )
)(AnalysisReports);
